import React, { useEffect, useState } from "react";
import { FaExclamationTriangle, FaInfoCircle, FaExclamationCircle } from "react-icons/fa";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Alert from "../UI/Alert/Alert";
import Spinner from "../UI/Spinner/Spinner";
import Activity from "../../containers/Activity/Activity";
import AdvancedSecurity from "../../containers/AdvancedSecurity/AdvancedSecurity";
import MobileHomeStatus from "../../containers/MobileHome/MobileHomeStatus/MobileHomeStatus";
import BackHaul from "../../containers/BackHaul/BackHaul";
import Devices from "../../containers/Devices/Devices";
import EquipmentStatus from "../../containers/EquipmentStatus/EquipmentStatus";
import Firmware from "../../containers/Firmware/Firmware";
import JsonData from "../../containers/JsonData/JsonData";
import LocatePod from "../../containers/LocatePod/LocatePod";
import NetworkTroubleshooting from "../../containers/NetworkTroubleshooting/NetworkTroubleshooting";
import PodTroubleshooting from "../../containers/PodTroubleshooting/PodTroubleshooting";
import RouterTroubleshooting from "../../containers/RouterTroubleshooting/RouterTroubleshooting";
import WifiHealth from "../../containers/WifiHealth/WifiHealth";
import Confirm from "../UI/Confirm/Confirm";
import Box from "../../hoc/Box/Box";
import * as actions from "../../store/actions/index";
import classes from "./OverviewPage.css";
import QOE from "../../containers/QOE/QOE";
import Modal from "../UI/Modal/Modal";
import SecondSSID from "../../containers/SecondSSID/SecondSSID";
import WifiSecurity from '../../containers/WifiSecurity/WifiSecurity'
import AlertBanner from "../../shared/AlertBanner/AlertBanner";

const OverviewPage = (props) => {

	const [wifiHealthOpen, setWifiHealthOpen] = useState(false);
	const [displayFirmware, setDisplayFirmware] = useState(false);
	const [wifiServiceCheck, setWifiServiceCheck] = useState(false);
	const [displayLocatePodLed, setDisplayLocatePodLed] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [result, setResult] = useState();
	const [action, setAction] = useState();

	useEffect(() => {
		if (wifiServiceCheck && props?.location?.query?.wifiServiceCheck) {
			setWifiServiceCheck(true);
		}
	});

	useEffect(() => {
		const isSpecReady = sessionStorage.getItem('isSpectrumReady') === 'true';
		const type = sessionStorage.getItem('type');
		const isTenant = type?.includes('Tenant');
		if(isSpecReady || isTenant){
			props.getSpectrumStatus()
		}
	}, [])

	const onOpenModal = (result, action) => {
		setConfirmModal(true);
		setResult(result);
		setAction(action);
	};

	const confirmModalConfirmHandler = () => {
		props.onRestoreRouter(true);
		closeModal();
	};

	const closeModal = () => {
		setConfirmModal(false);
	};

	const confirmModalCancelHandler = () => {
		setConfirmModal(false);
	};

	const restoreHandler = () => {
		onOpenModal("This may take a few minutes.");
	};

	const handleLocatePod = () => {
		setDisplayLocatePodLed((prevState) => !prevState.displayLocatePodLed)
		const payload = {
			pSerial: props.selectedEquipment.serialNumber,
			mode: displayLocatePodLed === false ? true : false,
		};
		props.setLocatePod(payload);
	}

	const setEquipmentSelection = () => {
		props.onSetSelectedEquipment({
			displayAllEquipment: true,
			type: "equipment",
		});
	}

	const handleWifiHealthOpen = () => {
		setWifiHealthOpen(true);
	}

	const handleFirmwareOpen = () => {
		setDisplayFirmware(true);
	}

	const checkPodsStrength = () => {
		let podNames;
		props.claimedPods.forEach((val) => {
			if(props.wan.podTimer && props.wan.rebootPodId === val.id){
				return;
			}
			if (
				val.backHaul &&
				val.backHaul.metadata &&
				val.backHaul.metadata.freqBand &&
				(val.backHaul.metadata.freqBand.includes("2.4G") || val.backHaul.metadata.freqBand.includes("2.4g"))
			) {
				if (podNames !== undefined) {
					if (val.nickname) {
						podNames = podNames + " , " + val.nickname;
					} else {
						podNames = podNames + " , " + val.defaultName;
					}
				} else {
					if (val.nickname) {
						podNames = val.nickname;
					} else {
						podNames = val.defaultName;
					}
				}
			}
		});
		return podNames;
	}
	const getPodFreq = () => {
		let freq;
		let connectionState;
		props.claimedPods.forEach((val) => {
			if (props.selectedEquipment.podId === val.id) {
				freq = val.backhaulType;
				connectionState = val.connectionState;
			}
		});
		return { freq, connectionState };
	}



	const getSpectrumReadyMessage = () => {
		return  (
			<Box>
				<div className={classes.podStrengthMessage}>
					<div className={classes.ShortTitleArea}>
						<div className={classes.InfoRow}>
							<div>
								<FaInfoCircle color={"red"} fontSize={"30px"} style={{ marginRight: "10px" }} />
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "flex-start",
								}}
							>
								<div style={{ display: "flex" }}>
									<span style={{ textAlign: "center" }}> WiFi radios and router ports are currently disabled.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={classes.Spacer} />
			</Box>
		);
	}

	const getFirmwareUpdateRecommendationMsg = () => {
		let clickTxt = "Check >";
		return  (
		<Box>
			<div id="FirmwareUpdateRecomMsg" className={classes.firmwareUpdateRecomMsg}>
				<div className={classes.ShortTitleArea}>
					<div className={classes.InfoRow}>
						<div className={classes.ErrMsgMobview}>
							<FaInfoCircle color={"red"} style={{ marginRight: "10px" }} fontSize={"20px"} />
						</div>
						<div style={{ display: "flex" }}>
							<p id="FirmMsgStyling" className={classes.FirmMsgStyling}>
								Router is not on the targeted version. A firmware update is recommended.
								<a
									className={[classes.firmwareSectionDesk, classes.firmwareCheck].join(" ")}
									href="#firmwareSectionDesk"
									style={{ paddingLeft: "10px", textDecoration: "none" }}
									onClick={() => {
										handleFirmwareOpen();
									}}
								>
									{clickTxt}
								</a>
								<a
									className={[classes.firmwareSectionMob, classes.firmwareCheck].join(" ")}
									href="#firmwareSectionMob"
									style={{ paddingLeft: "0px", textDecoration: "none" }}
									onClick={() => {
										handleFirmwareOpen();
									}}
								>
									{clickTxt}
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className={classes.Spacer} />
		</Box>
		)
	}

	const getFirmwareVersionMessage = (
		<Box>
			<div className={classes.podStrengthMessage}>
				<div className={classes.ShortTitleArea}>
					<div className={classes.InfoRow}>
						<div>
							<FaExclamationTriangle color={"red"} fontSize={"30px"} style={{ marginRight: "10px" }} />
						</div>
						<div style={{ display: "flex" }}>
							<p style={{ textAlign: "center", paddingLeft: "5px" }}>Please Update Firmware </p>
							<hr className={classes.Separator} />
							<p style={{ textAlign: "center" }}>
								{" "}
								Router firmware version is not compatible with PODs integration
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className={classes.Spacer} />
		</Box>
	);


	const podStrengthMessage = () => {
		if (
			props.claimedPods?.length &&
			props.equipment?.selectedEquipment?.displayAllEquipment
		) {
			podNames = checkPodsStrength();
			if (podNames !== undefined) {

			return  (
				<Box>
					<div className={classes.podStrengthMessage}>
						<div id = 'Pod2GAlertMsg' className={classes.ShortTitleArea}>
							<div className={classes.InfoRow}>
								<div>
									<FaInfoCircle color={"red"} fontSize={"30px"} style={{ marginRight: "10px" }} />
								</div>

								<div style={{ display: "flex" }}>
									<p style={{ textAlign: "center" }}> EXTENDER(s) Connected at 2.4GHz</p>
								</div>
							</div>
						</div>
					</div>
					<div className={classes.Spacer} />
				</Box>
			)
			}else{
				return undefined;
			}
		}else{
			return undefined;
		}
	};


	const routerTroubleshooting = () => {
		let hideWifiSecurity = Object.entries(props.wifiSecurity?.wifiSecurity)?.filter((securityInfo) => {
			if(securityInfo[0].includes('PRIMARY') && securityInfo[1].userSelectedValueAllowed){
				return true;
			}else {
				return false;
			}
		})
		if (props.showTimeRemaining) {
			return <Spinner />;
		} else {
			if (
				props?.equipment?.selectedEquipment !== "undefined" &&
				props.equipment.selectedEquipment.routerId &&
				!props.equipment.selectedEquipment.podId
			) {
				return (
					<Box>
						{sessionStorage.getItem("featureFlags").includes("WPA") && hideWifiSecurity.length > 0 && (
							<>
							<WifiSecurity/>
							<div className={classes.Spacer} />
							</>
						)}
						<RouterTroubleshooting />
					</Box>
				);
			}
		}
	}

	const firmware = () => {
		return props?.equipment?.selectedEquipment?.displayAllEquipment ? (
			<Box>
				<Firmware
					deskId="firmwareSectionDesk"
					mobId="firmwareSectionMob"
					displayFirmware={displayFirmware}
					equipment={props.equipment}
					wan={props.wan}
					firmwareUpdate={props.firmwareUpdate}
				/>
				<div className={classes.Spacer} />
			</Box>
		) : <div />;
	}

	const networkTroubleshooting = () => {
		return props?.equipment?.selectedEquipment?.displayAllEquipment ? (
			<Box>
				<NetworkTroubleshooting />
				<div className={classes.Spacer} />
			</Box>
		) : <div />;
	}

	const backhaul = () => {
		return props?.equipment?.selectedEquipment !== "undefined" &&
			props.equipment.selectedEquipment?.podId
			? (
				<Box>
					<BackHaul equipment={props.equipment} wan={props.wan} />
					<div className={classes.Spacer} />
				</Box>)
			: <div />;
	}


	const podTroubleshooting = () => {
		return props?.equipment?.selectedEquipment !== "undefined" &&
			props.equipment.selectedEquipment?.podId
			? (
				<Box>
					<PodTroubleshooting />
					<div className={classes.Spacer} />
				</Box>)
			: <div />;
	}

	const activity = () => {
		return props?.selectedEquipment?.type === "pod" || props.selectedEquipment.type === "router"
			? <div />
			: (<Box>
				<Activity
					realBandwidth={props.realBandwidth}
					devicesByEquipment={props.devicesByEquipment}
					days={props.bandwidthDays}
				/>
				<div className={classes.Spacer} />
			</Box>);
	}

	const wifiHealth = () => {
		return props?.selectedEquipment?.type === "pod" || props.selectedEquipment.type === "router"
			? <div />
			: (<Box>
				<WifiHealth />
				<div className={classes.Spacer} />
			</Box>);
	}


	const equipmentStatus = () => {
		return props.selectedEquipment.type === "equipment" ? (
			<Box>
				<EquipmentStatus podNames={podNames} />
				<div className={classes.Spacer} />
			</Box>
		): <div />
	}

	const advancedSecurity = () => {
		return props?.selectedEquipment?.type === "equipment" && sessionStorage.getItem("featureFlags").includes("advancedSpec") && props?.advancedSecurity?.advancedSecurity?.listenOnly === false ? (
			<Box>
				<AdvancedSecurity calledFrom="overview" />
				<div className={[classes.Spacer].join(" ")} />
			</Box>
		): <div />
	}


	const mobileHomeStatus = () =>  {
		return !props.devicesLoading &&
		props.devicesLoaded &&
		props.mobileHomeMode &&
		props.selectedEquipment.type !== "pod" &&
		props.mobileHomeActive === "Active"
		? (
			<>
				<MobileHomeStatus
					devices={props.realWan && props.realWan.devices}
					mobileHomeMode={props.mobileHomeMode}
					mobileHomeActive={props.mobileHomeActive}
				/>
				<div className={[classes.Spacer].join(" ")} />
			</>
		) : undefined

	}

	const backToWifiService = () => {
		return (!wifiServiceCheck &&
			props?.location?.query?.wifiServiceCheck &&
			props.location.query?.type === props.selectedEquipment?.type &&
			(props.location.query?.itemId === props.selectedEquipment?.routerId ||
				props.location.query.itemId === props.selectedEquipment.podId))
			? (
				<div className={[classes.RegularButton, classes.backToWifiService].join(" ")}>
					<Link
						id="BackToWifiServiceCheck"
						to={{
							pathname: "/network",
							query: { wifiServiceCheckPageOpen: true },
						}}
						style={{ color: "#0073d1", textDecoration: "none" }}
						onClick={setEquipmentSelection}
					>
						{"<"} Back To Wifi Service Check
					</Link>
				</div>
			) : undefined;
	}

	const renderPspWarning = () => {
		const masterAcct = sessionStorage.getItem("masterAcct");
		const mac = sessionStorage.getItem("mac");
		const type = sessionStorage.getItem("type");

		const isMasterAccValid = sessionStorage.getItem("masterAcct") !== ("null" || null);
		const isMacValid = sessionStorage.getItem("mac") !== ("null" || null);

		const {
			tenantData,
			enablementStaus,
			specReadyConnectivity,
			spectrumStatus,
			spectrumStatusLoading,
			spectrumStatusError
		} = props;
	  const isSuspendedFromTenant =
			["SUSPENDED", "OFFLINE_SUSPENDED"].includes(tenantData?.connectionStatus) ||
			["SUSPENDED", "OFFLINE_SUSPENDED"].includes(tenantData?.residentPrivateNetwork?.opStatus)
		const isNoService = enablementStaus === "noService";
		const isTypeExclude = !["undefined", "unknown", "Business"].some(t => type?.includes(t));

		const isTenantAccount = type?.includes('Tenant');
		const isUnitAccount = sessionStorage.getItem('subclass') === 'UNIT';
		const isSpectrumReady = (sessionStorage.getItem('isSpectrumReady') === 'true' || isTenantAccount) || !specReadyConnectivity;
		const isSpectrumReadySuspended = spectrumStatus.data?.tenantWifiState?.includes("suspended")
		const spectrumDataLoaded = !spectrumStatusLoading && !spectrumStatusError;
		
		// Only show warning at "All Equipment" level
		const isAllEquipmentView = props.selectedEquipment?.type === "equipment";

		const shouldShowWarning =
			isAllEquipmentView && !isUnitAccount && (
				(isMasterAccValid && isMacValid && isSuspendedFromTenant && isNoService && isTypeExclude) ||
				(isSpectrumReady && isSpectrumReadySuspended && spectrumDataLoaded)
			);

		if(shouldShowWarning){
			return (
				<React.Fragment>
					<Alert
						AlertIcon="PSPAlertIcon"
						Icon={FaExclamationTriangle}
						iconColor="red"
						iconFontSize="28px"
						txtId = 'PSPAddressabilityTxt'
						textMessage="Customer connection has been suspended by property manager.
			Please have customer contact property manager"
					/>
					<div className={classes.Spacer} />
				</React.Fragment>
			);
		}
		return <div />;
	}

	const addressabilityWarning = () => {
		if (props.enablementStaus === "noService" && !sessionStorage.getItem("type")?.includes("undefined") && !sessionStorage.getItem("type")?.includes("unknown") && !sessionStorage.getItem('type')?.includes('Business') && !sessionStorage.getItem('type')?.includes('Tenant')) {
			return (
				<React.Fragment>
					<Alert
						AlertIcon="AddressbilityAlertIcon"
						Icon={FaExclamationTriangle}
						iconColor="red"
						iconFontSize="28px"
						txtId="AddressabilityTxt"
						textMessage={
							!props.checkingWan
								? "Router is disabled and may experience limited functionality. Please refer to the troubleshooting trees or CoPilot article HOW5466 for remedy to restore service."
								: "Restoring Service..."
						}
						buttonText={!props.checkingWan ? "Restore Service" : ""}
						buttonCallBack={!props.checkingWan ? restoreHandler : null}
						buttonId="AddressbilityRestoreBtn"
					/>
					<div className={classes.Spacer} />
				</React.Fragment>
			);
		}else{
			return undefined;
		}
	}

	const devices = (
		<>
			<Devices
				devicesByEquipment={props.devicesByEquipment}
				selectedEquipment={
					props.equipment && props.equipment.selectedEquipment
						? props.equipment.selectedEquipment
						: null
				}
			/>

			<div className={classes.Spacer} />
		</>
	)
const locatePod = () => { 
	return (props?.selectedEquipment.type === "pod" ?  (
		<>
		<Box>
			<LocatePod handleLocatePod={handleLocatePod} defaultLocatePod={defaultLocatePod} />
            
		</Box>
		<div className={classes.Spacer}/>
		</>
	) :<div className={classes.Spacer}/>)
	
}

	const Qoe = () => {
		return props?.selectedEquipment?.type === "pod" ? (
			<>
				<Box>
					<QOE
						selectedEquipment={props.selectedEquipment}
						freq={qoePodDetails?.freq}
						connectionState={qoePodDetails?.connectionState}
					></QOE>
				</Box>
				<div className={classes.Spacer} />
			</>
		) : <div className={classes.Spacer} />

	}

	const secondSSID = () => {
		return ( props?.selectedEquipment?.type === "equipment" &&
			<>
				<SecondSSID />
				<div className={classes.Spacer} />
			</>
		)
	}

	// const dwell = sessionStorage.getItem("specReadOn");
	// const isSpecReadyOn = dwell === "SPECREADON" ? true : false;

	const techMobile = sessionStorage.getItem("techMobile");
	let  podNames;

	const qoePodDetails = props?.selectedEquipment?.type === "Pod" ? getPodFreq() : undefined;
	// const spectrumReadyMessage = isSpecReadyOn && props.specReadyConnectivity === false ? getSpectrumReadyMessage() : <div />;

	const firmwareUpdateRecommendationMsg = props?.equipment?.selectedEquipment?.displayAllEquipment
											&& props?.firmware?.upgradeRecommendedPostOnboarding
											? getFirmwareUpdateRecommendationMsg()
											: (<Box><div></div></Box>);

	const firmwareVersionMessage = props?.firmwareUpdate?.upgradeRecommended ? getFirmwareVersionMessage : (<Box><div></div></Box>);

    
 
	const defaultLocatePod = (props.selectedEquipment.podId === props.locatePodId && props.locatePodValue) ? true : false; 

	const isWiFiDisabled = sessionStorage.getItem("featureFlags")?.includes('staticIP') && props.staticIPConfigData?.expectedResults?.customerPrefConfigType?.includes('STATIC-DHCP-NAT-WIRELESS') === false;

	return (
		<Box>

			<div className={[classes.MainContent, classes[props.selectedEquipment.type + "page"]].join(" ")}>
				<div className={classes.MainContentContainer}>
					{sessionStorage.getItem("featureFlags")?.includes("isVar") && <div style={{backgroundColor:"#054478", color:'#fff', textAlign:'center', padding:20, marignTop:-20, fontWeight:"bold",position:'relative'}}>VAR account in ABW some features and services may not be available.</div>}
					{addressabilityWarning()}
					{isWiFiDisabled && (
						<React.Fragment>
							<AlertBanner message="WiFi disabled per customer opt-out (SIP WOW)." />
							<div className={classes.Spacer} />
						</React.Fragment>
					)}
					{props.cellularData?.lteState?.connectionState?.active && (
						<React.Fragment>
							<Alert
								AlertIcon="CellularAlertIcon"
								Icon={FaExclamationTriangle}
								iconColor="#E8A817"
								iconFontSize="28px"
								txtId="CellularBackupTxt"
								textMessage={`Cellular backup is active \u2013 Invincible WiFi Router (${sessionStorage.getItem("vendorModel") || "SAC2V1K"}). Primary connection is down.`}
							/>
							<div className={classes.Spacer} />
						</React.Fragment>
					)}

					{renderPspWarning()}
					{backToWifiService()}
					{firmwareUpdateRecommendationMsg}
					{podStrengthMessage()}
					{firmwareVersionMessage}
					{!sessionStorage.getItem("featureFlags")?.includes("isVar") && advancedSecurity()}
                    {sessionStorage.getItem("type")?.includes("Business") && sessionStorage.getItem("featureFlags")?.includes("secondSSID") && secondSSID()}
					{equipmentStatus()}
					{backhaul()}
					{devices}

					{!sessionStorage.getItem("featureFlags")?.includes("isVar") && mobileHomeStatus()}

					{activity()}

					{routerTroubleshooting()}

					{podTroubleshooting()}

					{networkTroubleshooting()}

					{firmware()}
					
					{locatePod()}

					{Qoe()}

					<JsonData />
				</div>
			</div>
			<Modal show={confirmModal} modalClosed={closeModal}>
				<Confirm
					id="CustomerNetworkConfirm"
					action={action}
					result={result}
					confirm={confirmModalConfirmHandler}
					cancel={confirmModalCancelHandler}
					deviceGroupConfirmation
				/>
			</Modal>
		</Box>
	);
}


const mapStateToProps = (state) => ({
	specReadyConnectivity: state.spectrumReady.connectivity,
	spectrumStatus: state.spectrumReady.spectrumStatus,
	spectrumStatusLoading: state.spectrumReady.spectrumStatusLoading,
	spectrumStatusError: state.spectrumReady.spectrumStatusError,
	isAuthenticated: state.auth.token !== null,
	isPinxt: state.auth.pToken !== null,
	loggedinUserId: sessionStorage.getItem("userId"),
	account: state.settings.account,
	realDevices: state.devices.realDevices,
	devicesByEquipment: state.devices.devicesByEquipment,
	bandwidthDays: state.bandwidth.days,
	realBandwidth: state.bandwidth.realBandwidth,
	selectedEquipment: state.equipment.selectedEquipment,
	showTimeRemaining: state.settings.showTimeRemaining,
	wan: state.wan,
	enablementStaus: state.spectrumReady.status,
	realWan: state.wan.realWan,
	tenantData: state.wan.tenantData,
	mobileHomeMode:
		state.mobileHome.realMobileHome && state.mobileHome.realMobileHome.mode
			? state.mobileHome.realMobileHome.mode
			: null,
	equipment: state.equipment,
	firmware: state.settings.firmwareUpdate,
	locatePodValue: state.equipment.locatePodDisplayLED,
	locatePodId: state.equipment.locatePodId,
	mobileHomeActive:
		state.mobileHome.realMobileHome &&
			state.mobileHome.realMobileHome.subscription &&
			state.mobileHome.realMobileHome.subscription &&
			state.mobileHome.realMobileHome.subscription.status
			? state.mobileHome.realMobileHome.subscription.status
			: null,
	claimedPods: state.equipment.realEquipment ? state.equipment.realEquipment.claimedPods : [],
	advancedSecurity: state.advancedSecurity,
	devicesLoading: state.devices.loading,
	devicesLoaded: state.devices.loaded,
	checkingWan: state.wan.checkingWan,
	timerStart: state.wan.timerStart,
	wifiSecurity: state.wifiSecurity,
	cellularData: state.cellularBackup.cellularData,
	staticIPConfigData: state.staticIPConfig.staticIPConfigData,
	staticIPConfigError: state.staticIPConfig.error,
});

const mapDispatchToProps = (dispatch) => ({
	onShowSideMenu: () => {
		dispatch(actions.showSideMenu());
	},
	onRestoreRouter: () => dispatch(actions.rebootRouter(false, true)),

	onSetSelectedEquipment: (equipment) => {
		dispatch(actions.setSelectedEquipment(equipment));
	},
	setLocatePod: (payload) => {
		dispatch(actions.setLocatePod(payload));
	},
	getSpectrumStatus:()=> dispatch(actions.initGetSpectrumStatus()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OverviewPage));
